import { render, staticRenderFns } from "./PendencyRow.vue?vue&type=template&id=30b08680&scoped=true"
import script from "./PendencyRow.vue?vue&type=script&lang=js"
export * from "./PendencyRow.vue?vue&type=script&lang=js"
import style0 from "./PendencyRow.vue?vue&type=style&index=0&id=30b08680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b08680",
  null
  
)

export default component.exports